function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "background-quotes",
  fill: "#7DE2D1",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M31,58 L31,28.0362538 L16.9252874,28.0362538 L16.9252874,21.9033233 C16.9252874,17.8731118 20.6666667,15.5951662 26.0114943,15.5951662 L31,15.5951662 L31,0 L17.816092,0 C7.66091954,0 0,9.11178248 0,20.326284 L0,58 L31,58 Z M74,58 L74,28.0362538 L59.9252874,28.0362538 L59.9252874,21.9033233 C59.9252874,17.8731118 63.6666667,15.5951662 69.0114943,15.5951662 L74,15.5951662 L74,0 L60.816092,0 C50.6609195,0 43,9.11178248 43,20.326284 L43,58 L74,58 Z",
  id: "\\u201C"
})));

function SvgQuoteCgi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74px",
    height: "58px",
    viewBox: "0 0 74 58",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u201C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteCgi);
export default __webpack_public_path__ + "static/media/quote-cgi.5897c081.svg";
export { ForwardRef as ReactComponent };